import { capitalize } from 'utils';
import getFullname from 'utils/getFullname';

const getEmail = email => (email ? `(${email})` : '');

export const getPrimaryMemberName = contact => {
	return `${getFullname({
		firstname: contact.first_name,
		lastname: contact.last_name
	})} ${getEmail(contact.email)}`;
};

export const getMemberStatus = contact => {
	return capitalize(contact.member_status);
};

export const getMemberType = contact => {
	return capitalize(contact.membertype?.member_type);
};

export const getStats = contact => {
	const linked = contact.linked_members?.length ?? 0;
	const allowed = contact.membertype?.linked_limit ?? 0;

	return `${linked} of ${allowed} used`;
};

export const prepareMember = member => {
	return {
		fullname: getFullname({ firstname: member.first_name, lastname: member.last_name }),
		email: member.secondary_contact_email,
		id: member.secondary_contact_vid
	};
};

export const prepareContact = contact => {
	return {
		fullname: getFullname({
			firstname: contact.properties.firstname.value,
			lastname: contact.properties.lastname.value
		}),
		email: contact.properties.email.value,
		id: contact.vid
	};
};
